"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityService = exports.isEntityUID = exports.corePaths = exports.cmsEndpointPath = exports.uploadPluginPath = exports.usersPermissionsPluginPath = exports.scormPluginPath = exports.cmsPluginPath = void 0;
var tslib_1 = require("tslib");
exports.cmsPluginPath = "plugin::strapi-plugin-shapeshift-cms";
exports.scormPluginPath = "plugin::strapi-plugin-shapeshift-addon-scorm";
exports.usersPermissionsPluginPath = "plugin::users-permissions";
exports.uploadPluginPath = "plugin::upload";
exports.cmsEndpointPath = "/strapi-plugin-shapeshift-cms/admin";
exports.corePaths = {
    note: "".concat(exports.cmsPluginPath, ".note"),
    attendanceEntry: "".concat(exports.cmsPluginPath, ".attendance-entry"),
    searchTracking: "".concat(exports.cmsPluginPath, ".search-tracking"),
    course: "".concat(exports.cmsPluginPath, ".course"),
    courseEnrollment: "".concat(exports.cmsPluginPath, ".course-enrollment"),
    surveyQuestionBoolean: "".concat(exports.cmsPluginPath, ".survey-boolean-choice-question"),
    surveyQuestionDynamicForm: "".concat(exports.cmsPluginPath, ".survey-dynamic-form-question"),
    surveyQuestionRating: "".concat(exports.cmsPluginPath, ".survey-rating-question"),
    surveyQuestionSingleChoice: "".concat(exports.cmsPluginPath, ".survey-single-choice-question"),
    surveyQuestionMultipleChoice: "".concat(exports.cmsPluginPath, ".survey-multiple-choice-question"),
    surveyQuestionText: "".concat(exports.cmsPluginPath, ".survey-text-question"),
    survey: "".concat(exports.cmsPluginPath, ".survey"),
    questionBoolean: "".concat(exports.cmsPluginPath, ".boolean-choice-question"),
    questionSingleChoice: "".concat(exports.cmsPluginPath, ".single-choice-question"),
    questionMultipleChoice: "".concat(exports.cmsPluginPath, ".multiple-choice-question"),
    questionFillInTheBlank: "".concat(exports.cmsPluginPath, ".fill-the-blank-question"),
    questionMatchingOrder: "".concat(exports.cmsPluginPath, ".matching-order-question"),
    questionDragToOrder: "".concat(exports.cmsPluginPath, ".drag-to-order-question"),
    questionText: "".concat(exports.cmsPluginPath, ".text-question"),
    quiz: "".concat(exports.cmsPluginPath, ".quiz"),
    scorm: "".concat(exports.scormPluginPath, ".scorm"),
    webinar: "".concat(exports.cmsPluginPath, ".webinar"),
    lesson: "".concat(exports.cmsPluginPath, ".lesson"),
    report: "".concat(exports.cmsPluginPath, ".report"),
    import: "".concat(exports.cmsPluginPath, ".import"),
    users: "".concat(exports.usersPermissionsPluginPath, ".user"),
    quizResult: "".concat(exports.cmsPluginPath, ".quiz-result"),
    group: "".concat(exports.cmsPluginPath, ".group"),
    groupInviteToken: "".concat(exports.cmsPluginPath, ".group-invite-token"),
    lessonEnrollment: "".concat(exports.cmsPluginPath, ".lesson-enrollment"),
    quizEnrollment: "".concat(exports.cmsPluginPath, ".quiz-enrollment"),
    webinarEnrollment: "".concat(exports.cmsPluginPath, ".webinar-enrollment"),
    surveyEnrollment: "".concat(exports.cmsPluginPath, ".survey-enrollment"),
    scormEnrollment: "".concat(exports.scormPluginPath, ".scorm-enrollment"),
    emailTemplates: "".concat(exports.cmsPluginPath, ".email-template"),
    notification: "".concat(exports.cmsPluginPath, ".notification"),
    notificationLog: "".concat(exports.cmsPluginPath, ".notification-log"),
    libraryCarousel: "".concat(exports.cmsPluginPath, ".library-carousel"),
    libraryCarouselList: "".concat(exports.cmsPluginPath, ".library-carousel-list"),
    tag: "".concat(exports.cmsPluginPath, ".tag"),
    file: "".concat(exports.uploadPluginPath, ".file"),
    integrityCheck: "".concat(exports.cmsPluginPath, ".integrity-check")
};
var isEntityUID = function (identifier) {
    return identifier === null || identifier === void 0 ? void 0 : identifier.includes("::");
};
exports.isEntityUID = isEntityUID;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
exports.entityService = ({
    findMany: function (entityIdentifier, e) {
        return query("findMany", entityIdentifier, e);
    },
    findOne: function (entityIdentifier, id, e) {
        return query("findOne", entityIdentifier, id, e);
    },
    delete: function (entityIdentifier, id, e) {
        return query("delete", entityIdentifier, id, e);
    },
    update: function (entityIdentifier, id, e) {
        return query("update", entityIdentifier, id, e);
    },
    create: function (entityIdentifier, e) {
        return query("create", entityIdentifier, e);
    }
});
var query = function (method, entityIdentifier) {
    var _a;
    var additional = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additional[_i - 2] = arguments[_i];
    }
    var strapi = global.strapi;
    if (!strapi)
        throw new Error("Strapi global is not defined, unable to query entityService");
    var strapiFunction = strapi.entityService[method];
    if (!strapiFunction)
        throw new Error("".concat(method, " is an invalid strapi entityService function"));
    if (!entityIdentifier)
        throw new Error("Identifier not passed to entityService ".concat(method, ", or value is undefined. Please pass either a full UID or entity key"));
    if (typeof entityIdentifier !== "string")
        throw new Error("Identifier passed to entityService ".concat(method, " is invalid. Please pass either a full UID or entity key string"));
    var uid = (0, exports.isEntityUID)(entityIdentifier) ? entityIdentifier : exports.corePaths[entityIdentifier];
    return (_a = strapi.entityService)[method].apply(_a, tslib_1.__spreadArray([uid], additional, false));
};
